import { useContext } from "react";

import { AuthContext, IAuthContext } from "@/contexts/AuthContext/context";

export const useAuth = (): IAuthContext => {
	const ctx = useContext(AuthContext);
	if (!ctx) throw new Error("useAuth must be used within AuthProvider");
	return ctx;
};
